import { Component, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { MinhasResponsabilidadesService } from '../services/minhas-responsabilidades.service';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-minhas-responsabilidades-list',
  templateUrl: './minhas-responsabilidades-list.component.html',
  styleUrls: ['./minhas-responsabilidades-list.component.scss']
})
export class MinhasResponsabilidadesListComponent extends BaseListComponent<any> implements OnInit {

  list: any[];
  indYears: any[];

  constructor(
    private myService: MinhasResponsabilidadesService,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.myService.findAll().subscribe((res) => {
      this.list = res['list'];
      this.indYears = res['indYears'];
      this.loaded();
    });
  }

  viewProjeto(id: number) {
    return ['/projetos', 'projeto', id];
  }

  viewIndicador(data: any) {
    return ['/projetos', 'projeto', data?.pf_id, 'indicadores', data?.id];
  }

  viewEntregas(data: any) {
    return ['/projetos', 'projeto', data?.pf_id, 'entregas', data?.id];
  }
}
